module.exports = __webpack_public_path__ + "static/media/wheel-bg-layer.9ba567ec.svg";